<script setup lang="ts">

</script>

<template>
<div/>
</template>

<style>
.font-sebastian-bobby-regular {
  font-family: "SebastianBobbyRegular", sans-serif;
  font-style: normal;
}

.font-ivymode {
  font-family: "ivymode", "Ivy Mode", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.font-ivymode-bold {
  font-family: "ivymode", "Ivy Mode", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.font-ivymode-italic {
  font-family: "ivymode", "Ivy Mode", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.font-lato-light {
  font-family: "lato", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.font-lato-light-italic {
  font-family: "lato", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.font-lato-regular {
  font-family: "lato", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.font-lato-regular-italic {
  font-family: "lato", sans-serif;
  font-weight: 400;
  font-style: italic;
}

#rubin-items-wrapper {
  font-family: "lato", sans-serif;
  font-weight: 400;
  font-style: normal;
}

#rubin-items-wrapper .title {
  font-family: "ivymode", "Ivy Mode", sans-serif;
  font-weight: 400;
  font-style: normal;
}

</style>